export enum ListFormat {
  GRID = 'grid',
  LINE = 'line',
}
